import { TopBarThemedThemeSizeConfig } from './types';

const large: TopBarThemedThemeSizeConfig = {
  topBarThemed: {},
};

export default large;
